import { Badge, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import type { MouseEvent } from 'react';
import type { DirLeadStatusType } from '@econtractor/types';
import { useSettings } from 'context/SettingsContext';
import { tDirName } from 'utils/helpers/i18n/tDirName';

interface LeadNewStatusProps {
    onClick?: (e: MouseEvent, statusID: number) => void;
    title?: string;
    showAcceptStatus?: boolean;
    sm?: boolean;
    disabled?: boolean;
}

const LeadNewStatus = ({ onClick, title = '', showAcceptStatus = true, sm = true, disabled = false }: LeadNewStatusProps) => {
    const { t } = useTranslation(['Leads']);
    const { localSettings } = useSettings();

    const menu = (
        <Dropdown.Menu
            className="lead-status-menu shadow-sm"
            popperConfig={{ strategy: 'fixed' }}
            renderOnMount
        >
            {localSettings?.DIRS?.LeadStatus &&
                localSettings.DIRS.LeadStatus.map((lStatus: DirLeadStatusType) => {
                    const statusStyle = lStatus.statusJson?.statusStyle || 'danger';
                    return (
                        <Dropdown.Item
                            className={`lead-status-menu__item${!showAcceptStatus && lStatus.ID == 400 ? ' d-none' : ''}`}
                            key={lStatus.ID}
                            onClick={(e) => (onClick ? onClick(e as unknown as MouseEvent, lStatus.ID) : null)}
                        >
                            <Badge className="fs-12" bg={statusStyle}>
                                {tDirName(t, lStatus.i18nKey, lStatus.statusName) || t(`status.${lStatus.ID}`)}
                            </Badge>
                        </Dropdown.Item>
                    );
                })}
        </Dropdown.Menu>
    );

    return (
        <Dropdown>
            <Dropdown.Toggle
                className={sm ? '' : 'w-100'}
                size={sm ? 'sm' : undefined}
                variant="primary"
                disabled={disabled}
            >
                <span className="pe-1">{title}</span>
            </Dropdown.Toggle>

            {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
        </Dropdown>
    );
};

export default LeadNewStatus;
